import '../styles/Animation.css'
export default function Animation() {
    return (
        <div className="character">
            <div className="character__container character__container-animation">
                <div className="character__body">
                    <figure className="character__head">
                        <span className="leaf-left"><span className="after"></span></span>
                        <span className="leaf-left other"><span className="after"></span></span>
                        <span className="leaf-right"><span className="after"></span></span>
                        <span className="leaf-right other"><span className="after"></span></span>
                        <span className="stick"></span>
                    </figure>
                    <figure className="arms">
                        <span className="hand hand-left"></span>
                        <span className="hand hand-right"></span>
                    </figure>
                    <figure className="body">
                        <span className="face">
                            <span className="eyes">
                            <span className="eye eye-left"></span>
                            <span className="eye eye-right"></span>
                            </span>
                            <span className="smile">
                            <span className="throat"></span>
                            <span className="teeth"></span>
                            </span>
                        </span>
                    </figure>
                    <figure className="foot">
                        <span className="feet-left"></span>
                        <span className="feet-right"></span>
                    </figure>
                </div>
            </div>
        </div>
    )
}